import { render } from "./swiperThumbsGallery.vue?vue&type=template&id=0570125a"
import script from "./swiperThumbsGallery.vue?vue&type=script&lang=js"
export * from "./swiperThumbsGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__